import { TEmail, TEmailLog } from "@cakemail-org/ui-components-v2"
import { TButtonClick } from "@cakemail-org/ui-components-v2/dist/esm/components/button/types"


export type TEmailReportSideBar = {
    tagFilter: any
}

export type TEmailReportInformation = {
    lastLog?: TEmailLog | null
}

export type TEmailReportSmallPreview = {
    email?: TEmail | null,
    onClick: TButtonClick
}

export enum EEmailReportSmallPreviewView {
    desktop = "desktop",
    mobile = "mobile",
    heatmap = "heatmap",
}
